import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Svg } from "../svg/Svg";
export const SearchIcon = React.forwardRef((props, ref) => (_jsx(Svg, { "data-testid": "SearchIcon", ...props, ref: ref, children: _jsx("path", { fill: "currentColor", d: "M15.854,15.147,9.726,9.019a5.5,5.5,0,1,0-.707.707l6.128,6.128a.5.5,0,0,0,.707-.707ZM5.5,10A4.5,4.5,0,1,1,10,5.5,4.5,4.5,0,0,1,5.5,10Z" }) })));
SearchIcon.displayName = "SearchIcon";
